"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Fade = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Transition = _interopRequireWildcard(require("react-transition-group/Transition"));
var _Modal = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Modal.css") : void 0);
var _excluded = ["children"],
  _excluded2 = ["className", "isModal", "appear", "mountOnEnter", "timeout", "unmountOnExit"];
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var CSS_BLOCK = 'sapcnqr-modal';
var Fade = exports.Fade = function Fade(_ref) {
  var children = _ref.children,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var className = props.className,
    isModal = props.isModal,
    _props$appear = props.appear,
    appear = _props$appear === void 0 ? false : _props$appear,
    _props$mountOnEnter = props.mountOnEnter,
    mountOnEnter = _props$mountOnEnter === void 0 ? false : _props$mountOnEnter,
    _props$timeout = props.timeout,
    timeout = _props$timeout === void 0 ? 300 : _props$timeout,
    _props$unmountOnExit = props.unmountOnExit,
    unmountOnExit = _props$unmountOnExit === void 0 ? true : _props$unmountOnExit,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded2);
  var classnames = _bind.default.bind(_Modal.default);
  var fadeStyles = (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _Transition.ENTERING, "".concat(CSS_BLOCK, "__fade--in")), _Transition.ENTERED, "".concat(CSS_BLOCK, "__fade--in"));
  return /*#__PURE__*/_react.default.createElement(_Transition.default, (0, _extends2.default)({}, otherProps, {
    appear: appear,
    timeout: timeout,
    mountOnEnter: mountOnEnter,
    unmountOnExit: unmountOnExit
  }), function (status, innerProps) {
    return /*#__PURE__*/_react.default.cloneElement(children, _objectSpread(_objectSpread({}, innerProps), {}, {
      className: classnames(className, children.props.className, "".concat(CSS_BLOCK, "__fade"), fadeStyles[status], (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__fade--non-modal"), !isModal))
    }));
  });
};
Fade.displayName = 'Fade';
Fade.propTypes = {
  appear: _propTypes.default.bool,
  className: _propTypes.default.string,
  children: _propTypes.default.node,
  in: _propTypes.default.bool,
  isModal: _propTypes.default.bool,
  mountOnEnter: _propTypes.default.bool,
  timeout: _propTypes.default.number,
  unmountOnExit: _propTypes.default.bool
};
var _default = exports.default = Fade;